var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2268_6098)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0274 36.0548C27.9837 36.0548 36.0548 27.9837 36.0548 18.0274C36.0548 8.07114 27.9837 0 18.0274 0C8.07115 0 0 8.07114 0 18.0274C0 27.9837 8.07115 36.0548 18.0274 36.0548Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0274 35.5068C27.8323 35.5068 35.7808 27.5584 35.7808 17.7534C35.7808 7.94848 27.8323 0 18.0274 0C8.22245 0 0.273956 7.94848 0.273956 17.7534C0.273956 27.5584 8.22245 35.5068 18.0274 35.5068Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2268_6098",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 24,
    height: 25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5343 15.6716H18.3014V20.3291H24.7671C24.1644 23.288 21.6438 24.9867 18.3014 24.9867C14.3562 24.9867 11.1781 21.8086 11.1781 17.8634C11.1781 13.9182 14.3562 10.7401 18.3014 10.7401C20 10.7401 21.5342 11.3429 22.7397 12.3292L26.2466 8.82229C24.1096 6.95928 21.3699 5.80859 18.3014 5.80859C11.6164 5.80859 6.24658 11.1785 6.24658 17.8634C6.24658 24.5483 11.6164 29.9182 18.3014 29.9182C24.3288 29.9182 29.8082 25.5346 29.8082 17.8634C29.8082 17.1511 29.6986 16.3839 29.5343 15.6716Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2268_6098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1507 24.9868V10.7402L14.4658 17.8635L5.1507 24.9868Z",
    fill: "#FBBC05"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2268_6098",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 24,
    height: 25
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5343 15.6716H18.3014V20.3291H24.7671C24.1644 23.288 21.6438 24.9867 18.3014 24.9867C14.3562 24.9867 11.1781 21.8086 11.1781 17.8634C11.1781 13.9182 14.3562 10.7401 18.3014 10.7401C20 10.7401 21.5342 11.3429 22.7397 12.3292L26.2466 8.82229C24.1096 6.95928 21.3699 5.80859 18.3014 5.80859C11.6164 5.80859 6.24658 11.1785 6.24658 17.8634C6.24658 24.5483 11.6164 29.9182 18.3014 29.9182C24.3288 29.9182 29.8082 25.5346 29.8082 17.8634C29.8082 17.1511 29.6986 16.3839 29.5343 15.6716Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2268_6098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1507 10.7403L14.4658 17.8636L18.3014 14.5211L31.4521 12.3841V4.71289H5.1507V10.7403Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2268_6098",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 24,
    height: 25
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5343 15.6716H18.3014V20.3291H24.7671C24.1644 23.288 21.6438 24.9867 18.3014 24.9867C14.3562 24.9867 11.1781 21.8086 11.1781 17.8634C11.1781 13.9182 14.3562 10.7401 18.3014 10.7401C20 10.7401 21.5342 11.3429 22.7397 12.3292L26.2466 8.82229C24.1096 6.95928 21.3699 5.80859 18.3014 5.80859C11.6164 5.80859 6.24658 11.1785 6.24658 17.8634C6.24658 24.5483 11.6164 29.9182 18.3014 29.9182C24.3288 29.9182 29.8082 25.5346 29.8082 17.8634C29.8082 17.1511 29.6986 16.3839 29.5343 15.6716Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2268_6098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1507 24.9869L21.5891 12.3841L25.9178 12.9321L31.4521 4.71289V31.0143H5.1507V24.9869Z",
    fill: "#34A853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2268_6098",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 24,
    height: 25
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5343 15.6716H18.3014V20.3291H24.7671C24.1644 23.288 21.6438 24.9867 18.3014 24.9867C14.3562 24.9867 11.1781 21.8086 11.1781 17.8634C11.1781 13.9182 14.3562 10.7401 18.3014 10.7401C20 10.7401 21.5342 11.3429 22.7397 12.3292L26.2466 8.82229C24.1096 6.95928 21.3699 5.80859 18.3014 5.80859C11.6164 5.80859 6.24658 11.1785 6.24658 17.8634C6.24658 24.5483 11.6164 29.9182 18.3014 29.9182C24.3288 29.9182 29.8082 25.5346 29.8082 17.8634C29.8082 17.1511 29.6986 16.3839 29.5343 15.6716Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2268_6098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4521 31.0142L14.4658 17.8635L12.274 16.2197L31.4521 10.7402V31.0142Z",
    fill: "#4285F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2268_6098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36.0548,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.7f85fb599ce5d06af770d2ecbbba8f48.svg";
export { ForwardRef as ReactComponent };